import Layout from "../../layout";
import React, {useState, useEffect} from "react";
import {Container, Button} from "react-bootstrap";
import Form from "./form";
import DataTable from "./datatable";
import axios from 'axios';

function Index() {
    const [page, setPage] = useState(1);
    const [users, setUsers] = useState([]);
    const [change, setChange] = useState(0);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = 'Kullanıcılar';

        axios.get(`${process.env.REACT_APP_API_URL}/user`, {page: page ?? 1})
            .then(function (response) {
                if (response.data.status === true) {
                    if (page > response.data.pageCount) setPage(response.data.pageCount);
                    setUsers(response.data);
                    setLoading(false);
                } else {
                    console.log(response);
                }
            });
    }, [change]);

    const deleteItem = async (userId) => {
        await axios.post(`${process.env.REACT_APP_API_URL}/user/delete/${userId}`)
            .then(function (response) {
                if (response.data.status === true) {
                    setChange((change) => change + 1);
                } else {
                    console.log(response.data);
                }
            });
    }

    return (
        <Layout>
            {loading ?
                <img className="loading" src={require("../../../src/images/loading.gif")}/>
                :
                <>
                    <div className="bg-white mb-3 border-bottom py-2">
                        <Container className="d-flex justify-content-between align-items-center">
                            <h2 className="mb-0 fs-5">{document.title}</h2>

                            <Button className="py-1 px-3" onClick={(show) => setShow(true)}>Kullanıcı Ekle</Button>
                        </Container>
                    </div>
                    <Container>
                        <DataTable response={users} setPage={setPage} deleteItem={deleteItem} change={change}
                                   setChange={setChange} loading={loading}/>
                    </Container>

                    {show && <Form change={change} setChange={setChange} show={show} setShow={setShow}/>}</>

            }
        </Layout>
    );
}

export default Index;


